import React from 'react';
import { Drawer, Tabs, Button, Tooltip, Spin, Checkbox } from 'antd';
import { InboxOutlined, FileOutlined } from '@ant-design/icons';
import './index.css';

const AttachmentDrawer = ({
  open,
  onClose,
  hblNo,
  activeAttachmentTab,
  setActiveAttachmentTab,
  setSelectedAttachment,
  setSelectedAnAttachment,
  setAnEmailType,
  attachments,
  selectedArchiveAttachmentKeys,
  setSelectedArchiveAttachmentKeys,
  attachmentLoading,
  attachmentError,
  selectedAttachment,
  getFileIcon,
  renderAttachmentPreview,
  archiveEmailAttachmentsLoading,
  handleArchiveEmailAttachments,
  uploadedFiles,
  uploadedFilesLoading,
  uploadedFilesError,
  editingRemarkId,
  editingRemarkType,
  setEditingRemarkId,
  setEditingRemarkType,
  savingRemark,
  handleUpdateRemark,
  handleDeleteUploadedAttachment,
  fetchUploadedFiles,
  anAttachments,
  anAttachmentsLoading,
  anAttachmentsError,
  selectedAnAttachment,
  anEmailType,
  fetchAnAttachments,
  handleDeleteAnAttachment,
  FilesUploadPanel,
  AnAttachmentsPanel,
}) => {
  const attachmentsTabContent = attachmentLoading ? (
    <div className="email-loading">
      <Spin tip="Loading" size="large" />
    </div>
  ) : attachmentError ? (
    <div className="email-empty">{attachmentError}</div>
  ) : !attachments || attachments.length === 0 ? (
    <div className="email-empty">No email attachments</div>
  ) : (
    <div style={{ display: 'flex', height: 'calc(100vh - 200px)', gap: '16px' }}>
      <div style={{ flex: '1', display: 'flex', flexDirection: 'column', minWidth: '300px' }}>
        <div style={{ flex: 1, overflow: 'auto', border: '1px solid #f0f0f0', borderRadius: '4px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
            {attachments.map((item, index) => {
              const itemId = item._rowKey || item.id || item.attachment_id || index;
              const checked = selectedArchiveAttachmentKeys.includes(itemId);
              const isSelected = selectedAttachment && (
                (selectedAttachment._rowKey && selectedAttachment._rowKey === itemId)
                || (item.id && selectedAttachment.id === item.id)
                || (item.attachment_id && selectedAttachment.attachment_id === item.attachment_id)
              );
              return (
                <div
                  key={itemId}
                  onClick={() => setSelectedAttachment(item)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '8px 12px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: isSelected ? '#e6f7ff' : 'transparent',
                    borderLeft: isSelected ? '3px solid #1890ff' : '3px solid transparent',
                  }}
                >
                  <Checkbox
                    checked={checked}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                      const nextChecked = e.target.checked;
                      setSelectedArchiveAttachmentKeys((prev) => (
                        nextChecked
                          ? [...prev, itemId]
                          : prev.filter((key) => key !== itemId)
                      ));
                    }}
                  />
                  <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                    {getFileIcon(item.file_name)}
                  </div>
                  <Tooltip title={item.file_name}>
                    <div style={{ flex: 1, minWidth: 0, fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {item.file_name}
                    </div>
                  </Tooltip>
                  <div style={{ flexShrink: 0, fontSize: '12px', color: '#999', width: 72, textAlign: 'right' }}>
                    {item.CreatedAt || '--'}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div style={{ width: '50%', minWidth: '400px', border: '1px solid #d9d9d9', borderRadius: '4px', backgroundColor: '#fafafa' }}>
        {selectedAttachment ? (
          <div className="attachment-preview-content" style={{ height: 'calc(100% - 60px)', overflow: 'auto' }}>
            {renderAttachmentPreview()}
          </div>
        ) : (
          <div style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#999',
            fontSize: '14px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <FileOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
              <p>Select a file to preview</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Drawer
      rootClassName="attachment-drawer"
      title="Attachments & Files"
      placement="right"
      onClose={() => {
        onClose();
        setActiveAttachmentTab('attachments');
        setSelectedAttachment(null);
        setSelectedAnAttachment(null);
        setSelectedArchiveAttachmentKeys([]);
        setAnEmailType(0);
      }}
      open={open}
      width='80%'
      destroyOnClose
      extra={
        activeAttachmentTab === 'attachments'
          && attachments.length > 0
          && attachments.some((item) => String(item.FileName ?? item.file_name ?? item.fileName ?? '').trim() !== '') ? (
          <Button
            type="primary"
            icon={<InboxOutlined />}
            loading={archiveEmailAttachmentsLoading}
            onClick={handleArchiveEmailAttachments}
          >
            Archive
          </Button>
        ) : null
      }
    >
      <Tabs
        activeKey={activeAttachmentTab}
        onChange={(key) => {
          setActiveAttachmentTab(key);
          setSelectedAttachment(null);
          setSelectedAnAttachment(null);
          if (key !== 'attachments') {
            setSelectedArchiveAttachmentKeys([]);
          }
        }}
        items={[
          {
            key: 'attachments',
            label: `Attachments (${attachments.length})`,
            children: attachmentsTabContent,
          },
          {
            key: 'files',
            label: `Files (${uploadedFiles.length})`,
            children: (
              <FilesUploadPanel
                hblNo={hblNo}
                uploadedFiles={uploadedFiles}
                uploadedFilesLoading={uploadedFilesLoading}
                uploadedFilesError={uploadedFilesError}
                selectedAttachment={selectedAttachment}
                setSelectedAttachment={setSelectedAttachment}
                getFileIcon={getFileIcon}
                renderAttachmentPreview={renderAttachmentPreview}
                editingRemarkId={editingRemarkId}
                editingRemarkType={editingRemarkType}
                setEditingRemarkId={setEditingRemarkId}
                setEditingRemarkType={setEditingRemarkType}
                savingRemark={savingRemark}
                handleUpdateRemark={handleUpdateRemark}
                handleDeleteAttachment={handleDeleteUploadedAttachment}
                onUploadSuccess={fetchUploadedFiles}
              />
            )
          },
          {
            key: 'an_attachments',
            label: `AN/PU Attachments (${anAttachments.length})`,
            children: (
              <AnAttachmentsPanel
                hblNo={hblNo}
                anAttachments={anAttachments}
                anAttachmentsLoading={anAttachmentsLoading}
                anAttachmentsError={anAttachmentsError}
                selectedAnAttachment={selectedAnAttachment}
                setSelectedAnAttachment={setSelectedAnAttachment}
                anEmailType={anEmailType}
                setAnEmailType={setAnEmailType}
                getFileIcon={getFileIcon}
                renderAttachmentPreview={renderAttachmentPreview}
                editingRemarkId={editingRemarkId}
                editingRemarkType={editingRemarkType}
                setEditingRemarkId={setEditingRemarkId}
                setEditingRemarkType={setEditingRemarkType}
                savingRemark={savingRemark}
                handleUpdateRemark={handleUpdateRemark}
                handleDeleteAttachment={handleDeleteAnAttachment}
                onUploadSuccess={fetchAnAttachments}
              />
            )
          }
        ]}
      />
    </Drawer>
  );
};

export default AttachmentDrawer;
